export default {
    site: {},
    vars: []
}
